import { Obj, Str } from '@livecontrol/core-utils';
import type { Installer } from '../../../model';

export type Record =  Partial<{
    url: string;
    id: string;
    expirationTime: string;
    date_updated: string;
    date_created: string;
    app: string;
    notes: string;
    name: string;
}>;

export const normalize = (record?: Record): Installer | undefined => {
    const required = {
        id: Str.normalize(record?.id),
        software: (['EMS', 'LCS', 'Updater'] as const)
        .find(v => v.toLowerCase() === record?.app?.toLowerCase()),
        url: Str.normalize(record?.url),
        versionName: Str.normalize(record?.name),
        expirationTime: Str.normalize(record?.expirationTime),
        updatedAt: record?.date_updated ? new Date(record.date_updated) : undefined,
        createdAt: record?.date_created ? new Date(record.date_created) : undefined
    };

    if (!Obj.isHydrated(required)) {
        return undefined;
    }

    return { ...required, notes: Str.normalize(record?.notes) };
};
